const VALID_NUMBER_REGEX = /^(0|[1-9]\d*)(\.\d+)?$/;

export function sanitizeNumeric(input) {
  if (input === null || input === undefined) {
    return '';
  }
  return String(input).replace(/[^0-9.]/g, '');
}

function toRawString(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

export function normalizeNumber(value) {
  const numeric = sanitizeNumeric(value);
  if (numeric === '') {
    return '';
  }
  const parsed = Number.parseFloat(numeric);
  if (Number.isNaN(parsed)) {
    return '';
  }
  return String(parsed);
}

export function normalizeRange({ from, to } = {}) {
  const nextFrom = from == null ? from : normalizeNumber(from);
  const nextTo = to == null ? to : normalizeNumber(to);
  const bothPresent = nextFrom != null && nextFrom !== '' && nextTo != null && nextTo !== '';
  if (bothPresent && Number(nextTo) < Number(nextFrom)) {
    return { from: nextTo, to: nextFrom };
  }
  return { from: nextFrom, to: nextTo };
}

export function isInvalidNumber(value) {
  const str = toRawString(value);
  if (str === '') {
    return false;
  }
  return !VALID_NUMBER_REGEX.test(str);
}

export function validateRange({ from, to } = {}) {
  const errors = {};
  const fromStr = toRawString(from);
  const toStr = toRawString(to);

  if (isInvalidNumber(fromStr)) {
    errors.from = 'filters.range.invalid_number';
  }
  if (isInvalidNumber(toStr)) {
    errors.to = 'filters.range.invalid_number';
  }

  if (!errors.from && !errors.to && fromStr !== '' && toStr !== '' && Number(toStr) < Number(fromStr)) {
    errors.to = 'filters.range.to_less_than_from';
  }

  return { valid: Object.keys(errors).length === 0, errors };
}
